import httpClient from "../utils/httpClient";

export const AddToCart = async (params) => {
    const response = await httpClient.post(`/Cart/add-to-cart`, params);
    return response.data;
};

export const CartDelete = async (params) => {
    const response = await httpClient.post(`/Cart/delete-cart`, params);
    return response.data;
};


export const CartDeleteAll = async (params) => {
    const response = await httpClient.post(`/Cart/deleteall-cart`, params);
    return response.data;
};


export const GetCartCount = async () => {
    const response = await httpClient.post(`/Cart/get-cart-count`, {});
    return response.data;
};

export const UpdateCart = async (params) => {
    const response = await httpClient.post(`/Cart/update-cart`, params);
    return response.data;
};

export const GetMyCart = async () => {
    const response = await httpClient.post(`/Cart/cart-list`, {});
    return response.data || [];
};
